module.exports = {"fr-FR":{"components":{"lot-group-item-overlay":{"title":"Détails du poste"}}}}